if (!customElements.get('product-media-modal')) {
  customElements.define(
    'product-media-modal',
    class ProductMediaModal extends HTMLElement {
      constructor() {
        super();
        this.scale = 1;
        this.translateX = 0;
        this.translateY = 0;
        this.initialDistance = 0;
        this.initialScale = 1;
        this.lastTouchX = 0;
        this.lastTouchY = 0;
        this.isDragging = false;
        
        const zoomTriggers = document.querySelectorAll('media-gallery .light-box-zoom-trigger');
        if (!zoomTriggers.length) return;
        zoomTriggers.forEach((trigger) => {
          trigger.addEventListener('click', () => {
            const modal = document.querySelector(trigger.getAttribute('data-modal'));
            if (modal) modal.showModal(trigger);
          });
        });
        this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hideModal.bind(this, false));
        this.addEventListener('pointerup', (event) => {
          if (event.pointerType === 'mouse') this.hideModal();
        });
      }

      showModal(opener) {
        this.openedBy = opener;
        document.body.classList.add('overflow-hidden');
        this.setAttribute('open', '');
        this.showActiveMedia();
        this.setupTouchEvents();
      }

      hideModal() {
        document.body.classList.remove('overflow-hidden');
        this.removeAttribute('open');
        this.resetTransform();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView({ block: "nearest", inline: "center" });
      }

      setupTouchEvents() {
        const content = this.querySelector('.product-media-modal__content');
        
        // Remove existing event listeners
        content.removeEventListener('touchstart', this.boundTouchStart);
        content.removeEventListener('touchmove', this.boundTouchMove);
        content.removeEventListener('touchend', this.boundTouchEnd);
        
        // Bind event handlers
        this.boundTouchStart = this.handleTouchStart.bind(this);
        this.boundTouchMove = this.handleTouchMove.bind(this);
        this.boundTouchEnd = this.handleTouchEnd.bind(this);
        
        // Add touch events to content container
        content.addEventListener('touchstart', this.boundTouchStart, { passive: false });
        content.addEventListener('touchmove', this.boundTouchMove, { passive: false });
        content.addEventListener('touchend', this.boundTouchEnd, { passive: false });
        
        // Double tap to zoom
        this.lastTap = 0;
        content.addEventListener('touchend', (e) => {
          const currentTime = new Date().getTime();
          const tapLength = currentTime - this.lastTap;
          if (tapLength < 500 && tapLength > 0) {
            this.handleDoubleTap(e);
          }
          this.lastTap = currentTime;
        });
      }

      handleTouchStart(e) {
        if (e.touches.length === 1) {
          this.lastTouchX = e.touches[0].clientX;
          this.lastTouchY = e.touches[0].clientY;
          this.isDragging = true;
        } else if (e.touches.length === 2) {
          this.initialDistance = this.getDistance(e.touches[0], e.touches[1]);
          this.initialScale = this.scale;
        }
      }

      handleTouchMove(e) {
        if (e.touches.length === 2 || this.scale > 1) e.preventDefault();
        
        const activeMedia = this.querySelector('.product-media-modal__content .active');
        if (!activeMedia) return;
        
        if (e.touches.length === 1 && this.isDragging && this.scale > 1) {
          const deltaX = e.touches[0].clientX - this.lastTouchX;
          const deltaY = e.touches[0].clientY - this.lastTouchY;
          
          this.translateX += deltaX;
          this.translateY += deltaY;
          
          // Constrain pan within bounds
          const rect = activeMedia.getBoundingClientRect();
          const maxTranslateX = (rect.width * (this.scale - 1)) / 2;
          const maxTranslateY = (rect.height * (this.scale - 1)) / 2;
          
          this.translateX = Math.max(-maxTranslateX, Math.min(maxTranslateX, this.translateX));
          this.translateY = Math.max(-maxTranslateY, Math.min(maxTranslateY, this.translateY));
          
          this.lastTouchX = e.touches[0].clientX;
          this.lastTouchY = e.touches[0].clientY;
          
          this.updateTransform();
        } else if (e.touches.length === 2) {
          const currentDistance = this.getDistance(e.touches[0], e.touches[1]);
          const scaleChange = currentDistance / this.initialDistance;
          this.scale = Math.max(1, Math.min(4, this.initialScale * scaleChange));
          
          this.updateTransform();
        }
      }

      handleTouchEnd(e) {
        this.isDragging = false;
        
        if (this.scale <= 1) {
          this.resetTransform();
        }
      }

      handleDoubleTap(e) {
        const activeMedia = this.querySelector('.product-media-modal__content .active');
        if (!activeMedia) return;
        
        if (this.scale === 1) {
          this.scale = 2;
          const rect = activeMedia.getBoundingClientRect();
          const centerX = rect.width / 2;
          const centerY = rect.height / 2;
          const touchX = e.changedTouches[0].clientX - rect.left;
          const touchY = e.changedTouches[0].clientY - rect.top;
          
          this.translateX = (centerX - touchX) * (this.scale - 1);
          this.translateY = (centerY - touchY) * (this.scale - 1);
        } else {
          this.resetTransform();
        }
        this.updateTransform();
      }

      getDistance(touch1, touch2) {
        const dx = touch1.clientX - touch2.clientX;
        const dy = touch1.clientY - touch2.clientY;
        return Math.sqrt(dx * dx + dy * dy);
      }

      updateTransform() {
        const activeMedia = this.querySelector('.product-media-modal__content .active');
        if (activeMedia) {
          activeMedia.style.transform = `translate(${this.translateX}px, ${this.translateY}px) scale(${this.scale})`;
          activeMedia.style.transformOrigin = 'center center';
        }
      }

      resetTransform() {
        this.scale = 1;
        this.translateX = 0;
        this.translateY = 0;
        this.updateTransform();
      }
    }
  );
}